/**
 * Shared scroll utilities.
 *
 * Extracted from DetailHero.tsx (WI-48) so both DetailHero and CampCard can
 * import the same function without prop-threading.
 */

/**
 * Smooth-scroll to the coaches section heading, respecting
 * prefers-reduced-motion (uses 'auto' / instant when enabled).
 */
export function scrollToCoaches(): void {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.getElementById('coaches-heading')?.scrollIntoView({
    behavior: reducedMotion ? 'auto' : 'smooth',
    block: 'start',
  });
}
